import "./MainPage.css";

import NavBar from "./Components/NavBar/NavBar.jsx";
import CoursesList from "./Components/CoursesList/CoursesList";



export default function MainPage({user, getUserInfo, signOut}) {
    return (
        <div id="mainPageTopContainer">
            <NavBar user={user} signOut={signOut} />
            <CoursesList getUserInfo={getUserInfo} user={user}/>
        </div>
    );
}